<template>
  <v-container>
    <slot></slot>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>
